import React, { useRef } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import SimparyChat from "../wizard/SimparyChat";
import styles from "../../styles/components/product/ProductAskChat.module.css";

const DEFAULT_PROMPTS = [
  "Is this good for my use case?",
  "Compare to my #1 AI pick",
  "Any deal-breakers for me?",
];

const ProductAskChat = ({
  product,
  aiSession = null,
  expanded = false,
  onExpandedChange,
  prefillPrompt = null,
  onPrefillConsumed,
  suggestedPrompts = DEFAULT_PROMPTS,
  onSuggestedPrompt,
}) => {
  const chatRef = useRef(null);

  const productContext = product
    ? {
        id: product._id || product.id,
        name: product.name,
        brand: product.brand?.name || product.brand,
        price: product.price,
      }
    : null;

  const handleSuggestedClick = (prompt) => {
    onExpandedChange?.(true);
    onSuggestedPrompt?.(prompt);
  };

  if (!product) return null;

  return (
    <div className={styles.wrapper} id="product-ask-chat">
      {expanded ? (
        <div className={styles.chatCard}>
          <button
            type="button"
            className={styles.collapseBtn}
            onClick={() => onExpandedChange?.(false)}
            aria-label="Collapse chat"
            aria-expanded={true}
          >
            <FaChevronUp aria-hidden />
          </button>
          <div className={styles.promptChips}>
            {suggestedPrompts.map((prompt) => (
              <button
                key={prompt}
                type="button"
                className={styles.promptChip}
                onClick={() => handleSuggestedClick(prompt)}
              >
                {prompt}
              </button>
            ))}
          </div>
          <SimparyChat
            ref={chatRef}
            embedded
            panel
            mode="product"
            productContext={productContext}
            aiSession={aiSession}
            prefillPrompt={prefillPrompt}
            onPrefillConsumed={onPrefillConsumed}
            hideIdentityBanner
          />
        </div>
      ) : (
        <button
          type="button"
          className={styles.collapsedBar}
          onClick={() => onExpandedChange?.(true)}
          aria-expanded={false}
        >
          <span className={styles.collapsedTitle}>Ask Simpary about this product</span>
          <span className={styles.collapsedHint}>
            Specs, fit for your needs, or comparisons
          </span>
          <FaChevronDown className={styles.collapsedIcon} aria-hidden />
        </button>
      )}
    </div>
  );
};

export default ProductAskChat;
